import '../../../scss/bakery/components/production-fable.scss'

import { Body2, Link, TableCell, TableRow } from '@sainsburys-tech/fable'
import { SparkFilled } from '@sainsburys-tech/icons'
import React from 'react'

import { setCurrentPlanner } from '../../../utils/localStore'
import IMixSku from '../../types/IMixSku'

interface IProps {
  openQpig: (mixSku: IMixSku) => void
  mixSku: IMixSku
}

const MixSkusRowPending = (props: IProps) => {
  const { mixSku, openQpig } = props

  return (
    <TableRow key={mixSku.mixSkuId} id={`MixSkuId_${mixSku.mixSkuId}`}>
      <TableCell>
        <Link
          className='c-common-hover-over-cursor c-link-black'
          onClick={() => {
            setCurrentPlanner('bakery')
            openQpig(mixSku)
          }}
          testid='pending-mix-link'
        >
          <Body2>
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <span>{mixSku.skuName}</span>
              {mixSku.isCredibleProduct === true && (
                <SparkFilled className='c-star__icon' />
              )}
            </span>
          </Body2>
        </Link>
      </TableCell>
      <TableCell>
        <Body2>{mixSku.productionTarget}</Body2>
      </TableCell>
    </TableRow>
  )
}

export default MixSkusRowPending
